var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdmContentPreviewEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 5A1.4 1.4 0 004 6.4v10.533a1.4 1.4 0 001.4 1.4h4.822l7.111-7.11V6.4a1.4 1.4 0 00-1.4-1.4H5.4zm1.267 5.022c0-.319.258-.577.577-.577H13.2a.578.578 0 110 1.155H7.244a.578.578 0 01-.577-.578zm.577 2.09a.578.578 0 000 1.155h3.29a.578.578 0 000-1.156h-3.29z",
    fill: "#0CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.826 14.063a.592.592 0 000-.838l-.94-.94a.592.592 0 00-.837 0l-5.011 5.011a.508.508 0 00-.15.36v1.059c0 .28.228.508.509.508h1.06a.508.508 0 00.358-.15l5.011-5.01z",
    fill: "#6FE6B5"
  })));
}
export default __webpack_public_path__ + "static/edm-content-preview-edit.7707d3c7.svg";
export { SvgEdmContentPreviewEdit as ReactComponent };